// Add your custom JS here.
( function( $ ) {




    // PAGE TRANSITIONS
    $("a").click(function(event) {

        if ($(this).hasClass("notransition")) {
            return;
        }

        if ($(this).attr("target") === "_blank") {
            return;
        }

        var href = $(this).attr("href");
        if (href.startsWith("tel:") || href.startsWith("mailto:")) {
            return;
        }

        if (href.indexOf('#') !== -1) {
            return;
        }

        event.preventDefault();

        $(".page-transition-in").addClass("active");

        setTimeout(function() {
            window.location.href = href;
        }, 150);
    });

    function removeActiveClass() {
        var element = document.querySelector('.page-transition-in');
        if (element) {
            element.classList.remove('active');
        }
    }

    window.addEventListener('load', removeActiveClass);
    window.addEventListener('pageshow', removeActiveClass);




    // Functie om een cookie te lezen
    function getCookieValue(cookieName) {
        const cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            const cookiePair = cookies[i].split('=');
            if (cookiePair[0] === cookieName) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }

    // Voeg de waarde toe aan het inputveld op de checkoutpagina
    $(document).ready(function() {
        if ($('body').hasClass('woocommerce-checkout')) {
            const referredByInput = $('#referred_by');
            const userLinkValue = getCookieValue('userlink');
            if (referredByInput.length && userLinkValue) {
                referredByInput.val(userLinkValue);
            }
        } 
    });


    ////// SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {
        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });





    $(".menu-toggle").on("click", function () {
        $("#wrapper-menu, #wrapper-navbar").toggleClass("active");
    });


    var lastScrollTop = 0; // Stores the last scroll position

    $(window).scroll(function() {
        var scrollTop = $(this).scrollTop(); // Get the current scroll position

        // Check if we are 64px or more off the top
        if (scrollTop > 64) {
            $('#wrapper-navbar').addClass('off-top');
        } else {
            $('#wrapper-navbar').removeClass('off-top');
        }

        // Check if we are scrolling down or up
        if (scrollTop > lastScrollTop) {
            // Scrolling down
            if (scrollTop > 64) {
                $('#wrapper-navbar').addClass('hide');
            }
        } else {
            // Scrolling up
            $('#wrapper-navbar').removeClass('hide');
        }

        // Update lastScrollTop with the current scroll position
        lastScrollTop = scrollTop;
    });


    var eventSwiper = new Swiper('.event-swiper', {
        slidesPerView: "auto", // Default for larger screens
        spaceBetween: 24,
        navigation: {
            nextEl: '.event-swiper-next',
            prevEl: '.event-swiper-prev',
        },
        loop: false, // Optional: Add looping behavior
        breakpoints: {
            // When the window width is <= 768px (mobile)
            992: {
                slidesPerView: 3, // Set to auto on mobile
            }
        }
    });

    var carSwiper = new Swiper('.car-swiper', {
        slidesPerView: "auto", // Default for larger screens
        spaceBetween: 24,
        autoHeight: true,
        effect: "fade",
        loop: false, // Optional: Add looping behavior
        breakpoints: {
            // When the window width is <= 768px (mobile)
            992: {
                slidesPerView: 1, // Set to auto on mobile
            }
        },
        navigation: {
            nextEl: '.car-swiper-next',  // Target the next button
            prevEl: '.car-swiper-prev',  // Target the previous button
        },
        on: {
            init: function () {
                // Get only direct child slides of .stats-swiper for the total count (ignoring nested swipers)
                var totalSlides = document.querySelectorAll('.car-swiper > .swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)').length;
                document.querySelector('.car-swiper-count .total').textContent = totalSlides;
    
                // Set initial current slide number
                document.querySelector('.car-swiper-count .current').textContent = this.realIndex + 1;
            },
            slideChange: function () {
                // Update the current slide number in the counter
                document.querySelector('.car-swiper-count .current').textContent = this.realIndex + 1;
            }
        }
    });



    var bannerSwiper = new Swiper('.banner-swiper', {
        slidesPerView: 1,
        autoHeight: true,
        effect: 'fade',
        pagination: {
            el: '.banner-swiper-pagination',
            clickable: true,
        },
        autoplay: {
            delay: 5000, // 5 seconds
            disableOnInteraction: false,
        },
        fadeEffect: {
            crossFade: true
        },
        loop: true // Optional: Enable looping of slides
    });




    var Statsswiper = new Swiper('.stats-swiper', {
        slidesPerView: 1,           // Only 1 slide per view
        autoHeight: true,           // Adjust height dynamically
        effect: 'fade',             // Use fade effect
        fadeEffect: {
            crossFade: true
        },
        loop: true,                 // Enable loop for cycling through slides
        // autoplay: {
        //     delay: 5000,            // Autoplay with 5 seconds delay
        //     disableOnInteraction: false
        // },
        allowTouchMove: false,
        pagination: {
            el: '.stats-swiper-pagination',  // Pagination element
            clickable: true,
            renderBullet: function (index, className) {
                // Find only direct child slides within .stats-swiper (ignore nested .number-swiper slides)
                var slides = document.querySelectorAll('.stats-swiper > .swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)');
                var slide = slides[index];
                var logoImg = slide.querySelector('.logo img');
                
                // If the logo exists, insert it inside the pagination bullet
                if (logoImg) {
                    return '<span class="' + className + ' button neutral900"><img src="' + logoImg.src + '" alt="Logo"></span>';
                } else {
                    return '<span class="' + className + ' button neutral900"></span>';  // Empty bullet for slides without a logo
                }
            }
        },
        navigation: {
            nextEl: '.stats-swiper-next',  // Target the next button
            prevEl: '.stats-swiper-prev',  // Target the previous button
        },
        on: {
            init: function () {
                // Get only direct child slides of .stats-swiper for the total count (ignoring nested swipers)
                var totalSlides = document.querySelectorAll('.stats-swiper > .swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)').length;
                document.querySelector('.stats-swiper-count .total').textContent = totalSlides;
    
                // Set initial current slide number
                document.querySelector('.stats-swiper-count .current').textContent = this.realIndex + 1;
            },
            slideChange: function () {
                // Update the current slide number in the counter
                document.querySelector('.stats-swiper-count .current').textContent = this.realIndex + 1;
            }
        }
    });



    if ($(window).width() > 992) {
        // Ensure GSAP and plugins are loaded
        gsap.registerPlugin(SplitText, ScrollTrigger);

        // Function to create the word-by-word animation
        function animateHeaders() {
            // Select all h1 and h2 elements
            const headers = document.querySelectorAll("h1, h2");

            headers.forEach(header => {
                // Split text into words
                const split = new SplitText(header, { type: "words" });

                // Set initial visibility of the header itself (parent) to hidden
                gsap.set(header, { opacity: 1, visibility: "visible" });

                // Animate the words inside the header
                const animation = gsap.from(split.words, {
                    opacity: 0,
                    y: 50,
                    stagger: 0.1, // Delay between word reveals
                    duration: 0.6, // Snappy animation duration
                    ease: "power2.out", // Smooth but snappy easing
                    delay: header.getBoundingClientRect().top < window.innerHeight ? 0.3 : 0, // 300ms delay for onload, none for scroll-triggered
                    onComplete: () => split.revert(), // Clean up SplitText after the animation finishes
                });

                // Apply ScrollTrigger if the element is outside the viewport
                ScrollTrigger.create({
                    trigger: header,
                    start: "top 80%", // Start the animation when the header is 80% in the viewport
                    toggleActions: "play none none none", // Play the animation when it enters the viewport
                    animation: animation,
                });
            });
        }

        // Run the function as soon as the DOM is fully loaded
        window.addEventListener("load", animateHeaders);
    }









    $(".story-card").on("click", function () {
        var storyId = $(this).attr("story");
        $("#story-popup-" + storyId + "").parent().addClass("active");
    });

    $(".backdrop .close").on("click", function () {
        $(".backdrop").removeClass("active");
    });

    $(".backdrop").on("click", function (e) {
        // Check if the clicked element is the backdrop itself (not a child)
        if (e.target === e.currentTarget) {
            $(".backdrop").removeClass("active");
        }
    });




    $(".faq-item .question").on("click", function (e) {
        $(this).toggleClass("active").siblings().slideToggle(300);
    });


    $(".buy-ticket-toggle").on("click", function (e) {
        $(".buy-event").addClass("active");
    });

    $(".buy-event .back").on("click", function (e) {
        $(".buy-event").removeClass("active");
    });







    if ($("body").hasClass("single-product")) {
        $('.quantity').prepend('<button type="button" class="qty-minus"><i class="icon-minus"></i></button>');
        $('.quantity').append('<button type="button" class="qty-plus"><i class="icon-plus"></i></button>');

        // Handle click on the minus button
        $('.qty-minus').on('click', function() {
            var $qty = $(this).siblings('input.qty'); // Find the quantity input field
            var currentVal = parseInt($qty.val());
            if (!isNaN(currentVal) && currentVal > parseInt($qty.attr('min'))) {
                $qty.val(currentVal - 1); // Decrease the value by 1
                $qty.trigger('change');
            }
        });

        // Handle click on the plus button
        $('.qty-plus').on('click', function() {
            var $qty = $(this).siblings('input.qty'); // Find the quantity input field
            var currentVal = parseInt($qty.val());

            if (!isNaN(currentVal) && currentVal < parseInt($qty.attr('max'))) {
                $qty.val(currentVal + 1); // Increase the value by 1
                $qty.trigger('change');
            }
        });
    }
    
    // ADD CAR ON ACCOUNT CREATION
    $("#misha_file").change(function () {
        if (!this.files.length) {
            $("#misha_filelist").empty();
        } else {
            // we need only the only one for now, right?
            const file = this.files[0];

            $("#misha_filelist").html(
                '<img src="' +
                    URL.createObjectURL(file) +
                    '"><span>' +
                    file.name +
                    "</span>"
            );

            const formData = new FormData();
            formData.append("misha_file", file);

            $.ajax({
                url: wc_checkout_params.ajax_url + "?action=mishaupload",
                type: "POST",
                data: formData,
                contentType: false,
                enctype: "multipart/form-data",
                processData: false,
                success: function (response) {
                    $('input[name="misha_file_field"]').val(response);
                },
            });
        }
    });

    //if clicked on 'show-more' button

    $(".show-more").on("click", function () {

        //toggle text 
        if ($(this).text() == "Toon meer") {
            $(this).text("Toon minder");
        } else {
            $(this).text("Toon meer");
        }

        //toggle maxheigth
        $(this).parent().toggleClass("show");

    });

    //scroll the .events .heading-wrapper synchronously with the heading-event-name
    $(".events .content-wrapper").scroll(function () {
        $(".events .heading-wrapper").scrollLeft($(this).scrollLeft());
    });

    $(".woocommerce-orders-table__row").scroll(function () {
        $(".woocommerce-orders-table tr").scrollLeft($(this).scrollLeft());
    });

    $(".dashboard-mobile-toggle").on("click", function () {
        $(".section-dashboard-sidebar").toggleClass("active");
    });



    $(".toggle-media").on("click", function () {
        $("#media-overview").addClass("active");
    });

    $("#media-overview .close").on("click", function () {
        $("#media-overview").removeClass("active");
    });

    $("#media-overview .views>div").on("click", function () {
        $(this).addClass("active").siblings().removeClass("active");
        var gridtype = $(this).attr("grid-type");
        $(".image-grid-inner").removeClass("one two three").addClass(gridtype);
    });



    $(".affiliate-info").on("click", function () {
        $(".affiliate-popup").addClass("active");
    });

    $(".affiliate-popup .close").on("click", function () {
        $(".affiliate-popup").removeClass("active");
    });



    // Check if we are on a single product page
    if ($('body').hasClass('single-product')) {
        // Check if the user is logged in
        var isUserLoggedIn = $('body').hasClass('logged-in');

        // Find the variation select fields
        var variationSelect = $('form.variations_form select');

        if (variationSelect.length) {
            variationSelect.each(function () {
                var options = $(this).find('option');

                // Check if the options include "Leden" and "Gasten"
                var hasLeden = options.filter('[value="leden"]').length > 0;
                var hasGasten = options.filter('[value="gasten"]').length > 0;

                if (hasLeden && hasGasten) {
                    // Set the value based on login status
                    if (isUserLoggedIn) {
                        $(this).val('leden').trigger('change'); // Set to "Leden" and trigger change event
                    } else {
                        $(this).val('gasten').trigger('change'); // Set to "Gasten" and trigger change event
                    }
                } else if (hasLeden) {
                    // Only "Leden" is available, set it as the value
                    $(this).val('leden').trigger('change');
                } else if (hasGasten) {
                    // Only "Gasten" is available, set it as the value
                    $(this).val('gasten').trigger('change');
                }
            });
        }
    }





    // Check if the cookie exists
    if (!getCookie('newplatform_popup_shown')) {
        // Show the popup after 1 second
        setTimeout(function() {
            $('.newplatform-backdrop').fadeIn();
        }, 1000);

        // Set a cookie to prevent showing it again
        setCookie('newplatform_popup_shown', 'true', 30); // Expires in 30 days
    }

    // Close the popup on clicking the close button
    $('.newplatform-popup .close').on('click', function() {
        $('.newplatform-backdrop').fadeOut();
    });

    // Close the popup when clicking the backdrop (but not the popup itself)
    $('.newplatform-backdrop').on('click', function(e) {
        if ($(e.target).is('.newplatform-backdrop')) {
            $('.newplatform-backdrop').fadeOut();
        }
    });

    // Function to set a cookie
    function setCookie(name, value, days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toUTCString();
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

   



  
} )( jQuery );